import React from "react";

import {makeStyles, createStyles} from "@material-ui/core/styles";
import {Pagination} from "@material-ui/lab";
import {Typography} from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      "& > *": {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(6),
        display: "flex",
        justifyContent: "center",
        color: theme.palette.text.primary,
      },
    },
  })
);

type PaginationControlledProps = {
  page: number;
  maxPage: number;
  pageChange: (page: number) => void;
};

const PaginationControlled = ({page, maxPage, pageChange}: PaginationControlledProps) => {
  const [currentPage, setPage] = React.useState<number>(page);
  const classes = useStyles();
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    pageChange(value);
  };
  // useEffect(() => {
  //   alert("Effected " + page);
  //   setPage(page);
  // },[page]);

  return (
    <div className={classes.root}>
      <Typography>Page: {currentPage}</Typography>
      <Pagination
        count={maxPage}
        page={currentPage}
        onChange={handleChange}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
      />
    </div>
  );
};

export default PaginationControlled;
